import { render, staticRenderFns } from "./NotificationsManagement.vue?vue&type=template&id=0fc3161f&scoped=true"
import script from "./NotificationsManagement.vue?vue&type=script&lang=ts"
export * from "./NotificationsManagement.vue?vue&type=script&lang=ts"
function injectStyles (context) {
  
  
}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "0fc3161f",
  null
  ,true
)

export default component.exports